import { Component, ChangeDetectionStrategy } from '@angular/core';
import { datadogLogs } from '@datadog/browser-logs';

@Component({
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="pl-pane">
      <se-fe-empty-state [seFeDataTitle]="title">
        <se-fe-icon seFeEmptyStateIcon seFeDataName="clipboard_thin" seFeDataSize="950"></se-fe-icon>
        {{ message }}
      </se-fe-empty-state>
    </div>
  `,
})
export class UnknownErrorComponent {
  title = "Whoa, that's not in the playbook";
  message = 'Something went wrong while trying to load the page. Please try again.';

  constructor() {
    datadogLogs.logger.error('Unknown Error', {
      url: window.location.href,
    });
  }
}
